import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import PropTypes from 'prop-types';
import MuiButton from '@automation/core/components/Button';
import s from './Button.css';

export default function Button({ theme, fullWidth, ...restProps }) {
  useStyles(s);
  return (
    <MuiButton className={`${s.button} ${s[theme] || ''} ${fullWidth ? s.fullWidth : ''}`} theme="no-theme" {...restProps} />
  );
}

Button.propTypes = {
  theme: PropTypes.oneOf(['low-theme', 'no-theme', 'white-theme', 'bordered-white-theme']),
  fullWidth: PropTypes.bool,
};

Button.defaultProps = {
  theme: 'no-theme',
  fullWidth: false,
};
